import { usePathname, useSearchParams } from "next/navigation";
import { useHotkeys } from "react-hotkeys-hook";
import { useCompanyDatabaseStore } from "~/app/sales/accounts/store";
import { usePeopleDatabaseStore } from "~/app/sales/contacts/store";
import { usePipelineSettingsStore } from "~/app/settings/pipelines/store";

import { routes } from "~/core/constants/routes";

import { useGlobalComposeEmailModalStore } from "~/components/GlobalComposeEmailModal/store";
import { useGlobalCreateOpportunityStore } from "~/components/GlobalNewOpportunityModal/store";
import { useGlobalCreateTaskStore } from "~/components/GlobalNewTaskModal/store";
import { useGlobalNoteModalStore } from "~/components/GlobalNoteModal/store";

import { useGlobalCommandbarStore } from "../store";

export const useOpeningShortcut = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const setIsOpenGlobalCommandbar = useGlobalCommandbarStore(
    st => st.setIsOpenGlobalCommandbar,
  );

  const setIsOpenGlobalCreateOpportunity = useGlobalCreateOpportunityStore(
    state => state.setIsOpenGlobalCreateOpportunity,
  );
  const setIsOpenAddCompanyModal = useCompanyDatabaseStore(
    state => state.setIsOpenAddCompanyModal,
  );
  const setIsOpenCreateContactModal = usePeopleDatabaseStore(
    state => state.setIsOpenCreateContactModal,
  );
  const setOpenGlobalComposeEmailModal = useGlobalComposeEmailModalStore(
    state => state.setOpenGlobalComposeEmailModal,
  );
  const setOpenGlobalCreateNoteModal = useGlobalNoteModalStore(
    state => state.setOpenGlobalCreateNoteModal,
  );
  const setIsOpenGlobalCreateTask = useGlobalCreateTaskStore(
    state => state.setIsOpenGlobalCreateTask,
  );
  const setIsOpenCreatePipelineModal = usePipelineSettingsStore(
    state => state.setIsOpenCreatePipelineModal,
  );

  useHotkeys("meta+k, /, c", keyboardEvent => {
    if (keyboardEvent.key === "c") {
      if (pathname.startsWith(routes.account.index)) {
        setIsOpenAddCompanyModal(true);
      } else if (pathname.startsWith(routes.contact.index)) {
        setIsOpenCreateContactModal(true);
      } else if (pathname.startsWith(routes.opportunity.index)) {
        setIsOpenGlobalCreateOpportunity(true);
      } else if (pathname.startsWith(routes.emails.index)) {
        setOpenGlobalComposeEmailModal(true);
      } else if (pathname.startsWith(routes.notes)) {
        setOpenGlobalCreateNoteModal(true);
      } else if (pathname.startsWith(routes.tasks)) {
        setIsOpenGlobalCreateTask(true);
      } else if (pathname.startsWith(routes.settings.pipelines.index)) {
        const hasPipelineIdInSearchParams = searchParams.get("pipeline_id");
        if (!hasPipelineIdInSearchParams) {
          setIsOpenCreatePipelineModal(true);
        }
      } else {
        setIsOpenGlobalCommandbar(true);
      }
      return;
    }
    setIsOpenGlobalCommandbar(true);
  });
};
